module.exports = __webpack_public_path__ + "static/banner_bg_4-4927dea3cb3d9c6dbf9909996d936486.png";